import axios from "axios";
import Config from "../_config/config";
import { IResponseBean } from "../_models/IResponseBean";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import myAxios from "./axiositeachWrapper";
import AuthenticationService from "./AuthenticationService";

export class ApiService {
  initSync() {
    let url: any = `${Config.baseUrl}rest/mobile/iteach/sync/init`;
    console.log(url, Config.customer, "here");
    return axios.post<any>(url, Config.customer);
  }

  syncBatches(instructorId: number) {
    // Updated to use nodefork endpoint which includes topics
    let url: any = `${Config.nodeSiteUrl}v1/sync/batches/${instructorId}`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  syncStudentsForBatch(batchId: number, templateSlotId?: number, actualSlotId?: number) {
    let url: any =
      `${Config.baseUrl}rest/mobile/iteach/sync/students/batch/` + batchId;

    const params = new URLSearchParams();
    if (templateSlotId) params.append('templateSlotId', String(templateSlotId));
    if (actualSlotId) params.append('actualSlotId', String(actualSlotId));

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    console.log(url);
    return axios.get<any>(url);
  }

  // Node replacement for syncStudentsForBatch — same response shape as the
  // Java endpoint so it's a drop-in for the Attendance screen.
  syncStudentsForBatchNode(batchId: number, templateSlotId?: number) {
    let url = `${Config.nodeSiteUrl}v1/attendance/students/batch/${batchId}`;
    if (templateSlotId) url += `?templateSlotId=${templateSlotId}`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  syncTimeTables(instructorId: number, batchIds: any) {
    // Migrated to nodefork endpoint for better batch filtering
    const url = `${Config.nodeSiteUrl}v1/schedules/timetables/by-batches`;
    console.log('Fetching timetables from nodefork:', { instructorId, batchIds });
    return myAxios.post<any>(url, { instructorId, batchIds });
  }

  syncLessonPlans(instructorId: number) {
    let url: any =
      `${Config.baseUrl}rest/mobile/iteach/sync/lessonplans/instructor/` +
      instructorId;
    console.log(url);
    return axios.get<any>(url);
  }

  // Node replacement for syncLessonPlans — same { status, data: LessonPlan[] }
  // envelope as the Java endpoint so it's a drop-in for the Lessonplan screen.
  syncLessonPlansNode(instructorId: number) {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/sync/lessonplans/${instructorId}`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  syncLessonPlanStepStatus(instructorId: number) {
    let url: any =
      `${Config.baseUrl}rest/mobile/iteach/sync/lessonplanstepstatus/instructor/` +
      instructorId;
    console.log(url);
    return axios.get<any>(url);
  }

  // Node replacement for syncLessonPlanStepStatus — fields mapped back to the
  // page's names (statusTypeId, stepId, startedDate) for round-trip parity.
  syncLessonPlanStepStatusNode(instructorId: number) {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/sync/step-status/${instructorId}`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  syncOutAttendnace(attendanceData: any) {
    let url: any = `${Config.baseUrl}rest/mobile/iteach/attendance/save`;
    console.log(url);
    return axios.post<any>(url, attendanceData);
  }

  syncOutMultipleBatchAttendance(attendanceData: any) {
    let url: any = `${Config.baseUrl}rest/mobile/iteach/attendance/save/multiple`;
    console.log(url);
    return myAxios.post<any>(url, attendanceData);
  }

  syncOutLessonplanStatus(lessonplanData: any) {
    // Updated to use nodefork endpoint with flip class resource assignment
    let url: any = `${Config.nodeSiteUrl}v1/lesson-plan/status/save`;
    console.log(url);
    return myAxios.post<any>(url, lessonplanData);
  }

  getLessonPlanStatusTypes() {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/status-types`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  getBioMetricStudentAttendance(batchId: number) {
    let url: any =
      `${Config.baseUrl}rest/mobile/iteach/sync/biometric/student/attendance/batch/` +
      batchId;
    console.log(url);
    return axios.get<any>(url);
  }

  // Node replacement for getBioMetricStudentAttendance — same envelope as Java
  getBioMetricStudentAttendanceNode(batchId: number) {
    const url = `${Config.nodeSiteUrl}v1/attendance/biometric/batch/${batchId}`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  getLessonplanStepAttachments(lessonplanStepId: number) {
    let url: any =
      `${Config.baseUrl}rest/mobile/iteach/lessonplan/step/` +
      lessonplanStepId +
      "/attachments";
    console.log(url);
    return axios.get<any>(url);
  }

  // Node replacement for getLessonplanStepAttachments — same
  // { status, message, data } envelope as the Java endpoint.
  getLessonplanStepAttachmentsNode(lessonplanStepId: number) {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/step/${lessonplanStepId}/attachments`;
    console.log(url);
    return myAxios.get<any>(url);
  }

  issueLessonplanStepTests(data: any) {
    let url: any = `${Config.baseUrl}rest/mobile/iteach/lessonplan/test/issue`;
    console.log(url);
    return axios.post<any>(url, data);
  }

  // Node replacement for issueLessonplanStepTests — same payload and the same
  // { status, message } contract the Lessonplan screen branches on.
  issueLessonplanStepTestsNode(data: any) {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/step-tests/issue`;
    console.log(url);
    return myAxios.post<any>(url, data);
  }

  getDashboards(userId: number) {
    //Staff level studyresource 29-DashBoard
    let url: any =
      `${Config.baseUrl}api/studyresources/type/` + 29 + "/user/" + userId;
    console.log(url);
    return axios.get<any>(url);
  }

  getDashBoardURL(resourceId: any) {
    let url: any =
      `${Config.baseUrl}api/studyresources/getDashboardUrl/` + resourceId;
    console.log(url);
    return axios.get<any>(url);
  }

  saveLocationAttendance(attendanceLocationData: any) {
    let url: any = `${Config.baseUrl}api/common/mobile/staff/attendance/save`;
    console.log(url);
    return axios.post<any>(url, attendanceLocationData);
  }

  getInstructorTimetable(timetableData: any) {
    let url: any = `${Config.baseUrl}api/common/timetable/instructor`;
    return axios.post<IResponseBean>(url, timetableData);
  } // ask suraj

  getFollowupDetails = (body) => {
    const url: string = `${Config.nodeSiteUrl}v1/followup/list`;
    return myAxios.post(url, body);
  };

  //getEnquiryDetails
  getEnquiryDetails(enquiryID: any) {
    let url: any = `${Config.baseUrl}api/common/listEnquiryHistory/${enquiryID}`;
    console.log(url);
    return axios.get<any>(url);
  }
  //getEnquiryFormControls
  getEnquiryFormControls() {
    const url = `${Config.nodeSiteUrl}v1/followup/init`;
    return myAxios.get<any>(url);
  }

  saveFollowupDetails = (body) => {
    const url: string = `${Config.nodeSiteUrl}v1/followup/save`;
    return myAxios.post(url, body);
  };

  getTestAnalysis = () => {
    const currentUser = AuthenticationService?.currentUserValue;
    const instructorId = currentUser?.instructorId;
    const url: string = `${Config.baseUrl}api/tm/instructor/${instructorId}/tests`;
    console.log(url);
    return myAxios(url);
  };

  getSearchFollowupFormConfigs = () => {
    const url: string = `${Config.baseUrl}rest/mobile/followup/search/fields`;
    console.log(url);
    return myAxios.get(url);
  };
  getStudentMarks(testId: any, batchIds: any[]) {
    const url = `${Config.nodeSiteUrl}v1/test-data-entry/student-marks`;
    return myAxios.post(url, { testId, batchIds });
  }

  getStudentMarksWithoutMissingRecordsInsertion(testId: any, batchIds: any[]) {
    const url = `${Config.nodeSiteUrl}v1/test-data-entry/student-marks/withoutsaving`;
    return myAxios.post(url, { testId, batchIds });
  }

  updateDataEntry(data: { id: any; type: string; value: any }) {
    const url = `${Config.baseUrl}api/tm/dataentry/update`;
    return myAxios.post<any>(url, data);
  }

  checkTestLock(testId: number, batchId: number) {
    const url = `${Config.baseUrl}api/common/test/dataentry/info`;
    return myAxios.post(url, { testId, batchIds: [batchId] });
  }
  getTestDetails(testId: number) {
    const url = `${Config.baseUrl}api/tm/${testId}/testDetails`;
    return myAxios.get(url);
  }

  getArReport = (query: string) => {
    const url = `${Config.nodeSiteUrl}v1/reports/ar-reports${query}`;
    return myAxios.get(url);
  };

  getAgentDailyReport = (body) => {
    const url = `${Config.baseUrl}api/common/dailyreports/details`;
    return myAxios.post(url, body);
  };

  generateNewCourse = (body) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/prompt`;
    return myAxios.post(url, body);
  };

  generateNewCourseStreaming = async (body, onChunk: (chunk: string) => void) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/prompt`;

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    // Add authentication token from localStorage (same as axios wrapper)
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser && currentUser !== 'undefined') {
      try {
        const user = JSON.parse(currentUser);
        const token = user.token;
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Failed to parse currentUser from localStorage:', error);
      }
    }

    // Add common headers if they exist
    const commonHeaders = myAxios.defaults.headers.common;
    if (commonHeaders && typeof commonHeaders === 'object') {
      Object.keys(commonHeaders).forEach(key => {
        const value = (commonHeaders as any)[key];
        if (typeof value === 'string') {
          headers[key] = value;
        }
      });
    }

    // 3-minute timeout for large AI generations
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 180000);

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ ...body, stream: true }),
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const reader = response.body?.getReader();
      const decoder = new TextDecoder();
      let fullResponse = '';
      let metadata: any = {};
      let buffer = ''; // Buffer for partial SSE lines across chunks

      if (!reader) {
        throw new Error('Response body is not readable');
      }

      const processSSELine = (line: string) => {
        if (!line.startsWith('data: ')) return;
        try {
          const data = JSON.parse(line.slice(6));

          if (data.error) {
            throw new Error(data.error);
          }

          if (data.chunk) {
            fullResponse += data.chunk;
            onChunk(data.chunk);
          }

          if (data.done) {
            metadata = {
              model: data.model,
              usage: data.usage,
              stop_reason: data.stop_reason,
            };
          }
        } catch (parseError: any) {
          // If it's a rethrown error from data.error, propagate it
          if (parseError.message && !parseError.message.includes('JSON')) {
            throw parseError;
          }
          console.warn('Failed to parse SSE line, skipping:', line, parseError);
        }
      };

      while (true) {
        const { done, value } = await reader.read();

        if (done) break;

        // Append decoded chunk to buffer to handle lines split across reads
        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        // Keep the last (possibly incomplete) line in the buffer
        buffer = lines.pop() || '';

        for (const line of lines) {
          processSSELine(line);
        }
      }

      // Flush any remaining data in the buffer after stream ends
      if (buffer.trim()) {
        processSSELine(buffer.trim());
      }

      console.log('[SSE] Stream complete. stop_reason:', metadata.stop_reason, 'response length:', fullResponse.length);

      return {
        data: {
          response: fullResponse,
          ...metadata,
        },
      };
    } finally {
      clearTimeout(timeoutId);
    }
  };

  generateLearningAnalytics = (body) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/prompt`;
    console.log(body);
    return myAxios.post(url, body);
  };

  getLessonPlanStepActivity = (params: {
    lessonPlanId: number;
    stepId: number;
    batchId: number;
    startDate?: string;
    endDate?: string;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/analytics/lesson-plan-step-activity`;
    return myAxios.get(url, { params });
  };

  getTestDashboardAnalytics = (params: {
    testId: number;
    batchId?: number;
    lessonPlanId?: number;
    stepId?: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/analytics/test-dashboard`;
    return myAxios.get(url, { params });
  };

  saveLearningModule = (body) => {
    // Save to nodefork study_resource_master table with Config JSON
    const url = `${Config.nodeSiteUrl}v1/study-resources/lesson-plans`;
    return myAxios.post(url, body);
  };

  saveLearningModuleWithFiles = (formData: FormData) => {
    // Use Node.js backend endpoint (supports proper UPDATE based on ID)
    const url = `${Config.nodeSiteUrl}v1/study-resources/lesson-plans/with-files`;
    return myAxios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  };

  getLearningResourceType = () => {
    const url = `${Config.nodeSiteUrl}v1/courses/types`;
    return myAxios.get(url);
  };

  getAllTags = (params?: { courseId?: number; typeId?: number; enabled?: boolean }) => {
    const url = `${Config.nodeSiteUrl}v1/tags`;
    return myAxios.get(url, { params });
  };

  searchTags = (query: string, courseId?: number) => {
    const url = `${Config.nodeSiteUrl}v1/tags/search`;
    return myAxios.get(url, { params: { q: query, courseId } });
  };

  getLessonPlans = (params?: {
    status?: string;
    analyticsDashboard?: string;
    sortBy?: string;
    sortOrder?: string;
  }) => {
    // Fetch from nodefork lesson_plan_master table
    const url = `${Config.nodeSiteUrl}v1/common/lesson-plans/active`;
    return myAxios.get(url, { params });
  };

  // Keep old method for backwards compatibility
  getActiveLessonPlans = () => {
    return this.getLessonPlans({ status: '1' });
  };

  updateLessonPlanStatus = (id: number, status: number) => {
    const url = `${Config.nodeSiteUrl}v1/common/lesson-plans/${id}/status`;
    return myAxios.patch(url, { status });
  };

  // Clone a lesson plan / learning module.
  // mode 'full' copies steps + their resources & tests; 'structure' copies steps only (empty).
  // name (optional) overrides the default "Copy of <source>" name.
  cloneLessonPlan = (id: number, mode: 'full' | 'structure' = 'full', name?: string) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/lesson-plans/${id}/clone`;
    return myAxios.post(url, { mode, name });
  };

  getLessonPlanDetails = (lessonPlanId: number) => {
    // Fetch from nodefork study_resource_master table
    const url = `${Config.nodeSiteUrl}v1/study-resources/lesson-plans/${lessonPlanId}`;
    return myAxios.get(url);
  };

  updateResourceTags = (resourceId: number, tagIds: number[]) => {
    // Update tags for a specific resource in study_resource_tag_mapping table
    const url = `${Config.nodeSiteUrl}v1/study-resources/resources/${resourceId}/tags`;
    return myAxios.put(url, { tagIds });
  };

  getCourses = () => {
    // Fetch all active courses
    const url = `${Config.nodeSiteUrl}v1/courses`;
    return myAxios.get<any>(url);
  };

  getRootTopics = () => {
    // Fetch all root topics (parentId is null)
    const url = `${Config.nodeSiteUrl}v1/topics/root`;
    return myAxios.get<any>(url);
  };

  getTopicsByIds = (ids: number[]) => {
    // Get topics by IDs
    const url = `${Config.nodeSiteUrl}v1/topics/byIds?ids=${ids.join(',')}`;
    return myAxios.get(url);
  };

  getBatchesByIds = (ids: number[]) => {
    // Get batches by IDs
    const url = `${Config.nodeSiteUrl}v1/batches/byIds?ids=${ids.join(',')}`;
    return myAxios.get(url);
  };

  getStudyResourceSubTypes = (typeId: number) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/sub-types?typeId=${typeId}`;
    return myAxios.get(url);
  };

  getIteachAppConfig = () => {
    const url = `${Config.nodeSiteUrl}v1/common/iteach-app-config`;
    return myAxios.get(url);
  };

  // Persist Quick Quiz "Test View Result" column config (enabled + display name) to
  // customer_detail_master.JsonConfig.test.testViewResult
  saveTestViewResultConfig = (
    // Column keys map to { enabled, label }; the reserved `configRoleIds` key
    // holds the roles allowed to open the Columns modal.
    testViewResult: Record<string, boolean | { enabled: boolean; label?: string } | number[]>,
  ) => {
    const url = `${Config.nodeSiteUrl}v1/common/test-view-result-config`;
    return myAxios.post(url, { testViewResult });
  };

  getActivitySlotBatchData = (activitySlotId) => {
    const url = `${Config.nodeSiteUrl}v1/courses/activitySlots/${activitySlotId}`;
    return myAxios.get(url);
  };

  getActivitySlotStudents = (activitySlotId) => {
    const url = `${Config.nodeSiteUrl}v1/courses/activitySlots/${activitySlotId}/students`;
    return myAxios.get(url);
  };

  saveActivitySlotAttendance = (activitySlotTemplateId, body) => {
    const url = `${Config.nodeSiteUrl}v1/courses/activitySlots/${activitySlotTemplateId}/attendance`;
    return myAxios.post(url, body);
  };

  getMenteesRegistration = ()=>{
    const user = AuthenticationService.currentUserValue;
    const url = `${Config.nodeSiteUrl}v1/approve-modules/advisor/${user.userId}`;
    return myAxios.get(url);
  }

  confirmStudentModule = (body)=>{
    const url = `${Config.nodeSiteUrl}v1/approve-modules/confirm`;
    return myAxios.post(url, body);
  }

  getStudentTermCourses = (enrollmentId)=>{
    const url = `${Config.baseUrl}rest/students/student/enrollment/${enrollmentId}/program/details`;
    return myAxios.get(url);
  }

  getTestsForBatchIds = (batchId)=>{
    const url = `${Config.baseUrl}api/golden/batches/${batchId}/tests`;
    return myAxios.get(url);
  }

  goLiveWithTimetable = (timetableRunId, templateName)=>{
    const url = `${Config.nodeSiteUrl}v1/academic/timecraft/create-activity-slots/${timetableRunId}`;
    return myAxios.post(url, templateName ? { templateName } : {});
  }

  getBoards = ()=>{
    const url = `${Config.nodeSiteUrl}v1/academic/timecraft/boards`;
    return myAxios.get(url);
  }

  // ============ AI Helper Methods for Learning Module Builder ============

  /**
   * Get AI-suggested tags for a learning resource
   */
  aiSuggestTags = (data: {
    resourceName: string;
    resourceContent?: string;
    resourceType?: string;
    availableTags: Array<{ id: number; name: string; code?: string; typeName?: string }>;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/courses/ai/suggest-tags`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Extract metadata from a URL (YouTube, reference links, etc.)
   */
  aiExtractUrlMetadata = (url: string) => {
    const apiUrl = `${Config.nodeSiteUrl}v1/courses/ai/extract-url-metadata`;
    return myAxios.post(apiUrl, { url });
  };

  /**
   * Generate content for a learning resource using AI
   */
  aiGenerateResourceContent = (data: {
    resourceName: string;
    resourceType: string;
    sectionName: string;
    chapterName: string;
    moduleContext?: {
      title: string;
      audience: string;
      difficulty: string;
      tone: string;
    };
    lessonPlanId?: number;
    courseId?: number;
    conversationContext?: Array<{ role: string; content: string }>;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/courses/ai/generate-resource-content`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Analyze module and suggest metadata (difficulty, duration, tone)
   */
  aiAnalyzeModule = (data: {
    moduleName: string;
    audience?: string;
    chapters?: Array<{
      name: string;
      sections: Array<{
        name: string;
        resources: Array<{ name: string; type: string }>;
      }>;
    }>;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/courses/ai/analyze-module`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Generate an AI quiz from PDFs attached to a learning module step
   */
  aiGenerateStepQuiz = (data: {
    pdfUrls: string[];
    articleIds?: number[];
    stepName: string;
    chapterName: string;
    moduleName: string;
    questionCount?: number;
    testDate?: string;
    bloomsTagTypeId?: number;
    phaseLabel?: string;
    conversationContext?: Array<{ role: string; content: string }>;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/ai-generate-step-quiz`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Preview: Generate AI quiz questions without saving to DB (for teacher review)
   */
  aiPreviewStepQuiz = (data: {
    pdfUrls: string[];
    articleIds?: number[];
    stepName: string;
    chapterName: string;
    moduleName: string;
    questionCount?: number;
    testDate?: string;
    bloomsTagTypeId?: number;
    phaseLabel?: string;
    conversationContext?: Array<{ role: string; content: string }>;
    topicIds?: number[];
    courseDocumentMode?: "priority" | "strict";
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/ai-preview-step-quiz`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Commit: Save teacher-approved questions as a test
   */
  aiCommitStepQuiz = (data: {
    questions: Array<{
      name: string;
      stemStatement: string;
      explanation: string;
      bloomsLevel?: string;
      choices: Array<{ name: string; choiceString: string; correctFlag: number }>;
    }>;
    stepName: string;
    testDate?: string;
    phaseLabel?: string;
    bloomsTagTypeId?: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/ai-commit-step-quiz`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Fetch flip-class phase configuration from database
   * Returns array of phase configs with tags, descriptions, and sort order
   */
  fetchFlipClassConfig = () => {
    const url = `${Config.nodeSiteUrl}v1/flip-class/config`;
    return myAxios.get(url);
  };

  /**
   * Fetch study resources issued to the logged-in staff member
   */
  getMyStaffResources = (params?: { typeId?: number; search?: string; limit?: number; offset?: number }) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/my-staff-resources`;
    return myAxios.get<any>(url, { params });
  };

  embedLessonPlan = (lessonPlanId)=>{
    const url = `${Config.nodeSiteUrl}v1/rag/lesson-plan/${lessonPlanId}/embed`;
    return myAxios.post(url);
  }
  
  getEmbededStatus = (lessonPlanId)=>{
    const url = `${Config.nodeSiteUrl}v1/rag/lesson-plan/${lessonPlanId}/status`;
    return myAxios.get(url);
  }
  
  queryLessonPlan = (body)=>{
    const url = `${Config.nodeSiteUrl}v1/rag/query`;
    return myAxios.post(url, body);
  }

  getResourceRagStatus = (resourceId) => {
    const url = `${Config.nodeSiteUrl}v1/rag/resource/${resourceId}/status`;
    return myAxios.get(url);
  }

  ragifyLessonPlan = (lessonPlanId) => {
    const url = `${Config.nodeSiteUrl}v1/rag/lesson-plan/${lessonPlanId}/ragify`;
    return myAxios.post(url);
  }

  /** Every indexed document across the whole RAG corpus (latest run per resource) */
  getRagCorpus = () => {
    const url = `${Config.nodeSiteUrl}v1/rag/corpus`;
    return myAxios.get(url);
  }

  // ========== Timetable Templates Management ==========

  /**
   * Get academic years from year_master for template form dropdowns
   */
  getYearMasters = () => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/year-masters`;
    return myAxios.get<any>(url);
  };

  /**
   * Get whether the system is program-based or course-based
   */
  getScheduleSystemConfig = () => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/system-config`;
    return myAxios.get<any>(url);
  };

  /**
   * Get academic terms for a given program
   */
  getTermsByProgram = (programId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/terms-by-program?programId=${programId}`;
    return myAxios.get<any>(url);
  };

  /**
   * Get active academic programs from academic_program_master
   */
  getPrograms = () => {
    const url = `${Config.nodeSiteUrl}v1/academic/programs-list`;
    return myAxios.get<any>(url);
  };

  /**
   * Get list of timetable templates with filters
   * @param filters Object with optional filters: name, yearId, programId, courseId, termId, batchId, activeStatus, startDate, endDate
   * @param pagination Object with page and limit
   */
  getTemplates = (filters: any = {}, pagination: any = { page: 1, limit: 50 }, sort: any = {}) => {
    const params = new URLSearchParams();
    if (filters.name) params.append('name', filters.name);
    if (filters.yearId) params.append('yearId', filters.yearId.toString());
    if (filters.programId) params.append('programId', filters.programId.toString());
    if (filters.courseId) params.append('courseId', filters.courseId.toString());
    if (filters.termId) params.append('termId', filters.termId.toString());
    if (filters.batchId) params.append('batchId', filters.batchId.toString());
    if (filters.activeStatus !== undefined) params.append('activeStatus', filters.activeStatus.toString());
    if (filters.startDate) params.append('startDate', filters.startDate);
    if (filters.endDate) params.append('endDate', filters.endDate);
    params.append('page', pagination.page.toString());
    params.append('limit', pagination.limit.toString());
    if (sort.sortBy) params.append('sortBy', sort.sortBy);
    if (sort.sortOrder) params.append('sortOrder', sort.sortOrder);

    const url = `${Config.nodeSiteUrl}v1/schedules-templates?${params.toString()}`;
    return myAxios.get<any>(url);
  };

  /**
   * Get detailed information about a specific template
   * @param templateId Template ID
   */
  getTemplateDetail = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}`;
    return myAxios.get<any>(url);
  };

  /**
   * Create a new timetable template
   * @param data Template data
   */
  createTemplate = (data: any) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Update an existing template
   * @param templateId Template ID
   * @param data Updated fields
   */
  updateTemplate = (templateId: number, data: any) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}`;
    return myAxios.patch<any>(url, data);
  };

  /**
   * Delete a template
   * @param templateId Template ID
   */
  deleteTemplate = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}`;
    return myAxios.delete<any>(url);
  };

  /**
   * Update batch associations for a template
   * @param templateId Template ID
   * @param batchIds Array of batch IDs to associate with the template
   */
  updateTemplateBatches = (templateId: number, batchIds: number[]) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/batches`;
    return myAxios.put<any>(url, { batchIds });
  };

  /**
   * Create a template from an existing board
   * @param boardId Board ID to copy slots from
   * @param templateData Template metadata (name, description, date range)
   */
  createTemplateFromBoard = (boardId: number, templateData: any) => {
    const url = `${Config.nodeSiteUrl}v1/academic/timecraft-board/${boardId}/create-template`;
    return myAxios.post<any>(url, templateData);
  };

  // ========== Instructor and Topic Search ==========

  /**
   * Search instructors by name, code, email, or phone
   * @param query Search query
   */
  searchInstructors = (query: string) => {
    const url = `${Config.nodeSiteUrl}v1/schedules/instructors/search?query=${encodeURIComponent(query)}`;
    return myAxios.get<any>(url);
  };

  /**
   * Search topics by name or code
   * @param query Search query
   */
  searchTopics = (query: string) => {
    const url = `${Config.nodeSiteUrl}v1/topics/search?q=${encodeURIComponent(query)}`;
    return myAxios.get<any>(url);
  };

  /**
   * Search instructors filtered by template's course and topic mappings
   * @param templateId Template ID
   * @param query Search query
   */
  searchInstructorsByTemplate = (templateId: number, query: string, batchIds?: number[]) => {
    let url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/instructors/search?query=${encodeURIComponent(query)}`;
    if (batchIds && batchIds.length > 0) url += `&batchIds=${batchIds.join(',')}`;
    return myAxios.get<any>(url);
  };

  /**
   * Search topics scoped to the selected batches (3-table join via
   * instructor_batch_mapping → topic_master → topic_instructor_mapping).
   */
  searchTopicsByTemplate = (templateId: number, query: string, batchIds?: number[]) => {
    let url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/topics/search?query=${encodeURIComponent(query)}`;
    if (batchIds && batchIds.length > 0) url += `&batchIds=${batchIds.join(',')}`;
    return myAxios.get<any>(url);
  };

  /**
   * Topics the selected instructor can teach for the selected batches.
   */
  getTopicsForInstructor = (templateId: number, instructorId: number, batchIds?: number[]) => {
    let url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/topics/for-instructor/${instructorId}`;
    if (batchIds && batchIds.length > 0) url += `?batchIds=${batchIds.join(',')}`;
    return myAxios.get<any>(url);
  };

  /**
   * Get instructors who teach a specific topic
   */
  getInstructorsForTopic = (templateId: number, topicId: number, batchIds?: number[]) => {
    let url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/instructors/for-topic/${topicId}`;
    if (batchIds && batchIds.length > 0) url += `?batchIds=${batchIds.join(',')}`;
    return myAxios.get<any>(url);
  };

  /**
   * Search batches by name or code
   * @param query Search query
   */
  searchBatches = (query: string, programId?: number) => {
    let url = `${Config.nodeSiteUrl}v1/schedules/batches/search?query=${encodeURIComponent(query)}`;
    if (programId) url += `&programId=${programId}`;
    return myAxios.get<any>(url);
  };

  // ========== Activity Slot Template Operations ==========

  /**
   * Add a new activity slot to a template
   * @param templateId Template ID
   * @param data Activity slot data
   */
  addActivitySlotTemplate = (templateId: number, data: any) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Update an activity slot
   * @param templateId Template ID
   * @param slotId Activity slot ID
   * @param data Updated fields
   */
  updateActivitySlotTemplate = (templateId: number, slotId: number, data: any) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/${slotId}`;
    return myAxios.patch<any>(url, data);
  };

  /**
   * Delete an activity slot
   * @param templateId Template ID
   * @param slotId Activity slot ID
   */
  deleteActivitySlotTemplate = (templateId: number, slotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/${slotId}`;
    return myAxios.delete<any>(url);
  };

  /**
   * Bulk delete multiple activity slot templates
   * @param templateId Template ID
   * @param slotIds Array of slot IDs to delete
   */
  bulkDeleteActivitySlotTemplates = (templateId: number, slotIds: number[]) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/bulk-delete`;
    return myAxios.post<any>(url, { slotIds });
  };

  /**
   * Swap two activity slot templates
   * @param templateId Template ID
   * @param slotIdA First slot ID
   * @param slotIdB Second slot ID
   * @param mode 'content' (instructor/topic/batches only) or 'full' (including date/time)
   */
  swapActivitySlotTemplates = (templateId: number, slotIdA: number, slotIdB: number, mode: 'content' | 'full', includeRoom = false) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/swap`;
    return myAxios.post<any>(url, { slotIdA, slotIdB, mode, includeRoom });
  };

  /**
   * Check for conflicts when adding/moving an activity slot
   * @param templateId Template ID
   * @param data Conflict check data (slotId, date, startTime, endTime, instructorId, batchIds)
   */
  checkSlotConflicts = (templateId: number, data: any) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/check-conflicts`;
    return myAxios.post<any>(url, data);
  };

  // ========== Approval Workflow (PSB B.1.a) ==========

  /**
   * Instructor (or scheduler) confirms a specific activity slot.
   * Combined with a Published parent template, the slot becomes visible to students.
   */
  confirmActivitySlot = (templateId: number, slotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/${slotId}/confirm`;
    return myAxios.post<any>(url, {});
  };

  /**
   * Attach a list of study resources to a conducted activity slot.
   * Java parity: POST /api/common/resource/addResourceIds (CommonAPIResource).
   * Idempotent — re-attaching the same resource is skipped.
   */
  attachResourcesToActivitySlot = (
    activitySlotId: number,
    resourceIds: number[],
  ) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/activity-slot/${activitySlotId}/attach`;
    return myAxios.post<any>(url, { resourceIds });
  };

  /**
   * Sync Zoom attendance for a single conducted slot.
   * Peer to syncZoomVideoForActivitySlot — independent function, independent
   * endpoint. Java parity: ZoomMeetingAttendanceListener's per-slot work.
   */
  syncZoomAttendanceForActivitySlot = (activitySlotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/sync-zoom-attendance/${activitySlotId}`;
    return myAxios.post<any>(url, {});
  };

  /**
   * Sync the Zoom recording → Vimeo → study_resource for a single conducted slot.
   * Peer to syncZoomAttendanceForActivitySlot — independent function, independent
   * endpoint. Java parity: ZoomMeetingVideoUploadListener's per-slot work.
   */
  syncZoomVideoForActivitySlot = (
    activitySlotId: number,
    options?: { forceVideoRefresh?: boolean },
  ) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/sync-zoom-video/${activitySlotId}`;
    return myAxios.post<any>(url, options ?? {});
  };

  /**
   * Read-only attendance view for a conducted activity slot.
   * Returns the header summary plus per-student attendance for the modal that
   * mirrors Java's loadAttendance(activitySlotId) popup.
   */
  getActivitySlotAttendanceView = (activitySlotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/attendance/activity-slot/${activitySlotId}/view`;
    return myAxios.get<any>(url);
  };

  /**
   * Confirm many slot templates at once (My Teaching Plan multi-select), so an
   * instructor doesn't have to click each slot individually.
   */
  bulkConfirmActivitySlots = (slotIds: number[]) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/activity-slots/bulk-confirm`;
    return myAxios.post<any>(url, { slotIds });
  };

  /**
   * Revoke a prior confirmation. Slot disappears from student views until re-confirmed.
   */
  unconfirmActivitySlot = (templateId: number, slotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/${slotId}/confirm`;
    return myAxios.delete<any>(url);
  };

  /**
   * Publish the entire timetable so confirmed slots become visible to students.
   */
  publishTemplate = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/publish`;
    return myAxios.post<any>(url, {});
  };

  /**
   * Pull a Published timetable back from student view.
   */
  unpublishTemplate = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/unpublish`;
    return myAxios.post<any>(url, {});
  };

  // ========== Rollback (PSB Section A 1.c) ==========

  /** Recent changes (audit log) for a timetable — newest first. */
  getRecentChanges = (
    templateId: number,
    opts: { limit?: number; onlyActive?: boolean } = {},
  ) => {
    const params = new URLSearchParams();
    if (opts.limit != null) params.set("limit", String(opts.limit));
    if (opts.onlyActive != null) params.set("onlyActive", String(opts.onlyActive));
    const qs = params.toString();
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/recent-changes${qs ? `?${qs}` : ""}`;
    return myAxios.get<any>(url);
  };

  /** Revert one change_log row. Used by per-row Revert + Cmd+Z undo. */
  revertChange = (changeId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedule-changes/${changeId}/revert`;
    return myAxios.post<any>(url, {});
  };

  /** Revert every change in a batch (e.g. apply-to-future-slots edit). */
  revertChangeBatch = (batchId: string) => {
    const url = `${Config.nodeSiteUrl}v1/schedule-changes/batch/${encodeURIComponent(batchId)}/revert`;
    return myAxios.post<any>(url, {});
  };

  // Snapshots (c)
  listSnapshots = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/snapshots`;
    return myAxios.get<any>(url);
  };
  createSnapshot = (templateId: number, body: { name?: string; description?: string }) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/snapshots`;
    return myAxios.post<any>(url, body);
  };
  restoreSnapshot = (templateId: number, snapshotId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/snapshots/${snapshotId}/restore`;
    return myAxios.post<any>(url, {});
  };

  // Versions (d)
  listVersions = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/versions`;
    return myAxios.get<any>(url);
  };
  createVersion = (templateId: number, body: { label?: string; description?: string }) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/versions`;
    return myAxios.post<any>(url, body);
  };
  restoreVersion = (templateId: number, versionId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/versions/${versionId}/restore`;
    return myAxios.post<any>(url, {});
  };
  diffVersions = (templateId: number, fromVersionId: number, toVersionId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/versions/diff?fromVersionId=${fromVersionId}&toVersionId=${toVersionId}`;
    return myAxios.get<any>(url);
  };

  /**
   * Get list of classrooms (rooms) for room selection
   * @param params Optional filters (centreId, isActive, minCapacity, maxCapacity, limit)
   */
  getClassrooms = (params?: { centreId?: number; isActive?: number; limit?: number }) => {
    const url = `${Config.nodeSiteUrl}v1/academic/classrooms`;
    return myAxios.get<any>(url, { params });
  };

  // ========== Week Pattern Operations ==========

  /**
   * Get week pattern for a template
   * @param templateId Template ID
   */
  getWeekPattern = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/week-pattern`;
    return myAxios.get<any>(url);
  };

  /**
   * Save week pattern for a template
   * @param templateId Template ID
   * @param pattern Array of pattern slots (dayOfWeek, startTime, endTime, instructorId, topicMasterId, etc.)
   */
  saveWeekPattern = (templateId: number, pattern: any[]) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/week-pattern`;
    return myAxios.post<any>(url, { pattern });
  };

  /**
   * Generate date-specific activity slots from week pattern
   * Creates slots for all dates in the template range based on the week pattern
   * @param templateId Template ID
   */
  generateSlotsFromPattern = (templateId: number, startDate?: string, endDate?: string) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/generate-from-pattern`;
    return myAxios.post<any>(url, { startDate, endDate });
  };

  // ========== Excel Import Operations ==========

  /**
   * Get reference data (instructors + topics) for Excel template generation
   * @param templateId Template ID
   */
  getReferenceData = (templateId: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/reference-data`;
    return myAxios.get<any>(url);
  };

  /**
   * Bulk import date-specific slots from parsed Excel data
   * @param templateId Template ID
   * @param data Object with slots array and mode ('add' | 'replace')
   */
  bulkImportSlots = (templateId: number, data: { slots: any[]; mode: string }) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/activity-slots/bulk-import`;
    return myAxios.post<any>(url, data);
  };

  /**
   * Bulk import week pattern entries from parsed Excel data
   * @param templateId Template ID
   * @param data Object with pattern array and mode ('add' | 'replace')
   */
  bulkImportPattern = (templateId: number, data: { pattern: any[]; mode: string }) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/week-pattern/bulk-import`;
    return myAxios.post<any>(url, data);
  };

  // ========== Conflict Report ==========

  /**
   * Run a conflict report across activity slot templates in a date range.
   */
  runConflictReport = (params: {
    startDate: string;
    endDate: string;
    templateIds?: number[];
    boardId?: number;
    page?: number;
    limit?: number;
    exportAll?: boolean;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/conflict-report`;
    return myAxios.post<any>(url, params);
  };

  // ========== Instructor Dashboard ==========

  /**
   * Get unified instructor dashboard data (template slots + actual slots + attendance + lesson plans)
   * @param instructorId The instructor's employee ID
   * @param startDate Optional start date filter (YYYY-MM-DD)
   * @param endDate Optional end date filter (YYYY-MM-DD)
   */
  getInstructorDashboard = (instructorId: number, startDate?: string, endDate?: string) => {
    const params = new URLSearchParams({ instructorId: String(instructorId) });
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/instructor-dashboard?${params.toString()}`;
    return myAxios.get<any>(url);
  };

  /**
   * Template-scoped equivalent of the instructor dashboard. Returns UnifiedSlot[]
   * for every activity slot in the given timetable template, plus template
   * metadata and a small analytics block. Default window: [today-30d, today+7d];
   * explicit YYYY-MM-DD overrides win.
   */
  getTemplateDashboard = (templateId: number, startDate?: string, endDate?: string) => {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);
    const qs = params.toString();
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/${templateId}/dashboard${qs ? `?${qs}` : ''}`;
    return myAxios.get<any>(url);
  };

  /**
   * Fetch recorded videos for a given activity slot template.
   * Returns { status: 1, studyResources: [...] } when videos exist,
   * or { status: 2, message: "No videos available" } when none.
   */
  getRecordedVideosForSlot = (activitySlotTemplateId: number, batchId?: number) => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/recorded-videos`;
    return myAxios.post<any>(url, { activitySlotTemplateId, batchId });
  };

  getInstructorProfileStats = () => {
    const url = `${Config.nodeSiteUrl}v1/academic/instructor-profile-stats`;
    return myAxios.get<any>(url);
  };

  // ========== LCS Access Request ==========

  submitLcsAccessRequest = (body: {
    lessonPlanStepId: number;
    lessonPlanId: number;
    batchId: number;
    userId: number;
    reason?: string;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request`;
    return myAxios.post<any>(url, body);
  };

  getLcsAccessRequestStatus = (params: {
    lessonPlanStepId: number;
    batchId: number;
    userId: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request/status`;
    return myAxios.get<any>(url, { params });
  };

  getPendingLcsAccessRequests = () => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request/pending`;
    return myAxios.get<any>(url);
  };

  reviewLcsAccessRequest = (requestId: number, body: {
    action: "APPROVED" | "REJECTED";
    reviewedByUserId: number;
    remarks?: string;
    unlockDurationHours?: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request/${requestId}/review`;
    return myAxios.post<any>(url, body);
  };

  getAllLcsAccessRequests = (params: { status?: string; search?: string; page?: number; pageSize?: number }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request/all`;
    return myAxios.get<any>(url, { params });
  };

  bulkReviewLcsAccessRequests = (body: {
    requestIds: number[];
    action: "APPROVED" | "REJECTED";
    reviewedByUserId: number;
    remarks?: string;
    unlockDurationHours?: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lcs-access-request/bulk-review`;
    return myAxios.post<any>(url, body);
  };

  getLockStates = (lessonPlanId: number, batchId: number, userId?: number) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/lock-states`;
    const params: any = { lessonPlanId, batchId };
    if (userId) params.userId = userId;
    return myAxios.get<any>(url, { params });
  };

  deleteStepResourceMapping = (body: {
    stepId: number;
    studyResourceId?: number;
    testId?: number;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/step-resource-mapping`;
    return myAxios.delete(url, { data: body });
  };

  // Batch step dates for lesson plans
  getBatchStepDates = (lessonPlanId: number) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/${lessonPlanId}/batch-step-dates`;
    return myAxios.get<any>(url);
  };

  saveBatchStepDates = (lessonPlanId: number, batchId: number, steps: Array<{ stepId: number; plannedStartDate: string | null; plannedEndDate: string | null }>) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/${lessonPlanId}/batch-step-dates`;
    return myAxios.put<any>(url, { batchId, steps });
  };

  issueToBatches = (lessonPlanId: number, data: {
    batchIds: number[];
    startDate?: string;
    endDate?: string;
    schoolId?: number;
    yearId?: number;
    programId?: number;
    courseId?: number;
    courseIds?: number[];
    notifySms?: boolean;
    notifyEmail?: boolean;
    notifyApp?: boolean;
    smsMessage?: string;
    emailMessage?: string;
    appMessage?: string;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/${lessonPlanId}/issue-to-batches`;
    return myAxios.post<any>(url, data);
  };

  getIssueHistory = (lessonPlanId: number) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/${lessonPlanId}/issue-history`;
    return myAxios.get<any>(url);
  };

  deleteIssue = (lessonPlanId: number, issueId: number) => {
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/${lessonPlanId}/issue/${issueId}`;
    return myAxios.delete<any>(url);
  };

  // Study Resource issue-to-batches (same DB table, different route prefix)
  issueResourceToBatches = (resourceId: number, data: {
    batchIds: number[];
    startDate?: string;
    endDate?: string;
    schoolId?: number;
    yearId?: number;
    programId?: number;
    courseId?: number;
    courseIds?: number[];
    notifySms?: boolean;
    notifyEmail?: boolean;
    notifyApp?: boolean;
    smsMessage?: string;
    emailMessage?: string;
    appMessage?: string;
  }) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/${resourceId}/issue-to-batches`;
    return myAxios.post<any>(url, data);
  };

  getResourceIssueHistory = (resourceId: number) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/${resourceId}/issue-history`;
    return myAxios.get<any>(url);
  };

  deleteResourceIssue = (resourceId: number, issueId: number) => {
    const url = `${Config.nodeSiteUrl}v1/study-resources/${resourceId}/issue/${issueId}`;
    return myAxios.delete<any>(url);
  };

  getBatchesByFilters = (params: { schoolId?: number; courseId?: number; programId?: number; yearId?: number }) => {
    const query = new URLSearchParams();
    if (params.schoolId) query.set('schoolId', String(params.schoolId));
    if (params.courseId) query.set('courseId', String(params.courseId));
    if (params.programId) query.set('programId', String(params.programId));
    if (params.yearId) query.set('yearId', String(params.yearId));
    const url = `${Config.nodeSiteUrl}v1/lesson-plan/batches-by-filters?${query.toString()}`;
    return myAxios.get<any>(url);
  };

  getAcademicSchools = () => {
    const url = `${Config.nodeSiteUrl}v1/academic/schools`;
    return myAxios.get<any>(url);
  };

  getAcademicYears = () => {
    const url = `${Config.nodeSiteUrl}v1/academic/years`;
    return myAxios.get<any>(url);
  };

  getYearMastersForTemplates = () => {
    const url = `${Config.nodeSiteUrl}v1/schedules-templates/year-masters`;
    return myAxios.get<any>(url);
  };

  getAcademicPrograms = (yearIds?: string) => {
    let url = `${Config.nodeSiteUrl}v1/academic/programs`;
    if (yearIds) url += `?yearIds=${yearIds}`;
    return myAxios.get<any>(url);
  };

  getAcademicCourses = (yearId?: number, programId?: number) => {
    const params = new URLSearchParams();
    if (yearId) params.set('yearId', String(yearId));
    if (programId) params.set('programId', String(programId));
    const qs = params.toString();
    const url = `${Config.nodeSiteUrl}v1/academic/courses${qs ? `?${qs}` : ''}`;
    return myAxios.get<any>(url);
  };

  // List course documents available for given topicIds (lightweight, no extraction)
  listCourseDocuments = (topicIds: number[]) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/course-documents?topicIds=${topicIds.join(",")}`;
    return myAxios.get<{ documents: Array<{ id: number; name: string; typeId: number; typeName: string }> }>(url);
  };

  // AI resource generation (two-step: AI + web search for real URLs)
  generateLMResources = (data: {
    systemPrompt: string;
    topicIds?: number[];
    courseDocumentMode?: "priority" | "strict";
  }) => {
    const url = `${Config.nodeSiteUrl}v1/gen-ai/generate-resources`;
    return myAxios.post(url, data);
  };

  // Playground cache
  refreshPlaygroundCache = () => {
    return myAxios.post(`${Config.nodeSiteUrl}v1/playground/refresh-cache`);
  };
}

export default new ApiService();
